import { useWatch } from "react-hook-form";

import { TEMPLATE_TYPES } from "../../../constants";
import PreviewNoteDisplay from "../../../PreviewNoteDisplay";
import {
  TranscriptSampleChipMenu,
  RealNoteDisplay,
  TranscriptPreview,
  PreviewSourceToggle,
  PreviewLoadingState,
} from "../ExamplesChipMenu";

const PreviewingAgainstSample = ({
  control,
  handleClearSampleTranscript,
  previewSource,
  setPreviewSource,
  onOpenNotePicker,
  selectedNote,
}) => {
  const formData = useWatch({ control });

  return (
    <div className="flex flex-col gap-sm">
      <PreviewSourceToggle
        previewSource={previewSource}
        setPreviewSource={setPreviewSource}
      />
      {previewSource === "sample" ? (
        <>
          <TranscriptSampleChipMenu
            control={control}
            handleClearSampleTranscript={handleClearSampleTranscript}
          />
          <TranscriptPreview>
            {formData.sampleTranscript}
          </TranscriptPreview>
        </>
      ) : (
        <RealNoteDisplay
          selectedNote={selectedNote}
          onOpenNotePicker={onOpenNotePicker}
        />
      )}
    </div>
  );
};

const PreviewSection = ({
  control,
  loadingPreview,
  handleClearSampleTranscript,
  previewSource,
  setPreviewSource,
  onOpenNotePicker,
  selectedNote,
  previewContent,
}) => {
  const formData = useWatch({ control });

  return (
    <div className="w-full relative">
      {loadingPreview ? (
        <PreviewLoadingState
          previewSource={previewSource}
          selectedNote={selectedNote}
          sampleTranscript={formData.sampleTranscript}
        />
      ) : previewContent ? (
        <div className="relative w-full">
          <p className="text-sm text-secondary my-sm">
            Here's a preview of your template against the note or
            sample you selected. If you wish to try a different note
            or sample, click the <strong>Clear Preview</strong> button
            below.
          </p>
          <PreviewNoteDisplay
            previewContent={previewContent}
            isSoap={formData.templateType === TEMPLATE_TYPES.SOAP}
            dataTestId="preview-template-note"
          />
        </div>
      ) : (
        <div className="relative w-full">
          <PreviewingAgainstSample
            control={control}
            handleClearSampleTranscript={handleClearSampleTranscript}
            previewSource={previewSource}
            setPreviewSource={setPreviewSource}
            onOpenNotePicker={onOpenNotePicker}
            selectedNote={selectedNote}
          />
        </div>
      )}
    </div>
  );
};

export default PreviewSection;
